import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=21bb1854&scoped=true&"
import script from "./UserLayout.vue?vue&type=script&lang=js&"
export * from "./UserLayout.vue?vue&type=script&lang=js&"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=21bb1854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb1854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21bb1854')) {
      api.createRecord('21bb1854', component.options)
    } else {
      api.reload('21bb1854', component.options)
    }
    module.hot.accept("./UserLayout.vue?vue&type=template&id=21bb1854&scoped=true&", function () {
      api.rerender('21bb1854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/UserLayout.vue"
export default component.exports